import styled, { css } from "styled-components";
export const FooterWrap = styled.div `
    width: 100%;
    padding-top: 30px;
    background: #E6E6E6;
    font-size: 12px;
    a:hover {
        color: #e33124;
    }

    dl, dd {
        margin: 0;
    }
`;
export const FooterMain = styled.div `
    width: 1200px;
    margin: 0 auto;
`;
export const FooterHeader = styled.div `
    width: 100%;
    text-align: center;
    border-bottom: 0;
    margin-bottom: 30px;
    h2, h3 {
        display: inline-block;
        text-align: center;
        font: normal 24px helvetica,Arial;
        line-height: 1;
    }
    h3,em {
        font-size: 16px;
        font-weight: 500;
        color: #1a1a1a;
        margin-top: 0;
        margin-bottom: 0;
    }
    img {
        display: inline-block;
        width: 145px;
        height: 26px;
        vertical-align: middle;
    }
    em {
        font-style: normal;
    }
    sup {
        font-size: 12px;
        font-weight: normal;
        color: #1a1a1a;
        font-style: italic;
        margin-right: 10px;
    }
`;
export const WhyBuyFromUs = styled.div `
    margin: 0 auto;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;
    border-bottom: 1px solid #ccc;
`;
export const WhyBuyFromItem = styled.dl `
    text-align: center;
    dt {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        line-height: 19px;
        margin-bottom: 5px;
        padding-bottom: 0;
    };
    dd {
        font-size: 12px;
        font-weight: normal;
        color: #666;
        line-height: 16px;
    }
    img {
        display: inline-block;
        width: 34px;
        margin-bottom: 4px;
        vertical-align: middle;
    }
`;
export const NewFooterWrapper = styled.div `
    display: flex;
    justify-content: space-between;
    padding: 30px 0;
    border-bottom: 1px solid #ccc;
`;
export const OurNewsletters = styled.dl `
   dt {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin-bottom: 10px;
   };
   dd {
       margin-bottom: 0;
   }
`;
export const JoinOurWrap = styled.dl `
    dt {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin-bottom: 0;
    };
    dd {
        overflow: hidden;
        margin-top: 17px;
        margin-bottom: 0;
        display: flex;
        align-items: center;
    }
`;
export const JoinOurA = styled.a `
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 20px;
    color: #333;
    text-decoration: none;
    line-height: 1;
    background-image: url(${(props) => props.bgImg});
    background-size: cover;
    &:hover {
        background-image: url(${(props) => props.bghImg});
    }
`;
export const FooterSubAddr = styled.input.attrs({
    placeholderTextColor: "#999999"
}) `
    width: 229px;
    height: 35px;
    background: #fff;
    border-radius: 2px 0 0 2px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    border-right: 0;
    font-size: 14px;
    font-weight: normal;
    color: #333;
    outline: 0;
    line-height: 1px;
    vertical-align: top;
    padding: 3px 15px;
`;
export const FooterSubBtn = styled.input `
    height: 35px;
    background: #e33124;
    border-radius: 0 2px 2px 0;
    padding: 0 20px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    line-height: 35px;
    margin: 0;
    text-transform: none;
    border: none;
    outline: none;
    cursor: pointer;
`;
export const ErrorInfoEmail = styled.div `
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: normal;
    color: #e33124;
    line-height: 14px;
    padding-top: 5px;
`;
export const OurMobileApp = styled.dl `
    dt {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin-bottom: 10px;
    }
    dd {
        margin-bottom: 0;
    }
    a:hover {
        color: #fff;
    }
`;
export const OurMobileA = styled.a `
    display: inline-block;
    height: 35px;
    background: #333;
    border-radius: 2px;
    padding: 0 30px;
    font-size: 12px;
    font-weight: 500;
    color: #fff;
    line-height: 35px;
    width: auto;
    text-decoration: none;

	${(props) => props.isLast && css `
		margin-left: 10px;
	`}
    img {
        display: inline-block;
        width: 15px;
        margin-right: 7px;
        vertical-align: middle;
    }
`;
export const FooterWebsite = styled.div `
    display: flex;
    justify-content: space-between;
`;
export const AtoZ = styled.div `
    width: 385px;
    border-top: 1px solid #ccc;
    padding: 20px 0;
    border-bottom: 1px solid #ccc;
    flex-shrink: 0;
    flex-grow: 1;
    dt {
        margin-bottom: 12px;
    }
`;
export const SiteTitle = styled.a `
    width: auto;
    margin-right: 30px;
    vertical-align: middle;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    text-decoration: none;
`;
export const AZText = styled.a `
    font-size: 12px;
    font-weight: normal;
    color: #666;
    line-height: 16px;
    margin-right: 10px;
    text-decoration: none;
`;
export const RelatedLinks = styled.div `
    width: auto;
    display: flex;
    margin-bottom: 0;
`;
export const RelatedLink = styled.a `
    margin-left: 15px;
    max-width: 220px;
    padding: 20px 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    text-decoration: none;
    color: #333;
    display: inline-block;
    &:hover {
        dt, dd {
            color: #e33124;
        }
    }
    dt {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        line-height: 16px;
        margin: 3px 0 6px;
    }
    dd {
        font-size: 12px;
        font-weight: normal;
        color: #666;
        line-height: 16px;
    }
`;
export const CustomerHelp = styled.div `
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    padding: 30px 0;

    dl {
        float: none;
    }
    dt {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        padding-bottom: 4px;
    }
    dd {
        padding: 0;
    }
`;
export const CustomerLink = styled.a `
    font-size: 12px;
    font-weight: normal;
    color: #666;
    line-height: 24px;
    text-decoration: none;
`;
export const FooterPartners = styled.div `
    width: 100%;
    margin-top: 30px;
    text-align: center;
    padding-bottom: 15px;
    height: auto;
    overflow: hidden;
    .payment-icon {
        background: url("https://lijc.rightinthebox.com/lightsource/img/sprite/generated/new_footer_payement_logo_d1048bb2fa43a0b1.png") no-repeat;
        background-size: 76px 630px;
        margin-right: 15px!important;
        margin-bottom: 15px!important;
        margin-top: 0!important;
        vertical-align: bottom;
        display: inline-block;
        float: none;
    }
    .PayPal {
        height: 30px;
        width: 29px;
        background-position: 0 -30px;
    }
    .Visa {
        height: 30px;
        width: 57px;
        background-position: 0 -420px;
    }
    .MasterCard {
        height: 30px;
        width: 41px;
        background-position: 0 -60px;
    }
    .AE {
        height: 30px;
        width: 51px;
        background-position: 0 -330px;
    }
    .JCB {
        height: 30px;
        width: 45px;
        background-position: 0 -90px;
    }
    .Maestro {
        height: 30px;
        width: 50px;
        background-position: 0 -150px;
    }
    .DinersClub {
        height: 30px;
        width: 50px;
        background-position: 0 -210px;
    }
    .Discover {
        height: 30px;
        width: 50px;
        background-position: 0 -300px;
    }
    .CB {
        height: 30px;
        width: 57px;
        background-position: 0 -510px;
    }
    .Sofort {
        height: 30px;
        width: 49px;
        background-position: 0 -120px;
    }
    .iDeal {
        height: 30px;
        width: 50px;
        background-position: 0 -180px;
    }
    .Klarna {
        height: 30px;
        width: 51px;
        background-position: 0 -360px;
    }
    .Elo {
        height: 30px;
        width: 50px;
        background-position: 0 -270px;
    }
    .Boleto {
        height: 30px;
        width: 57px;
        background-position: 0 -450px;
    }
    .OXXO {
        height: 30px;
        width: 50px;
        background-position: 0 -240px;
    }
    .Westernunion {
        height: 30px;
        width: 57px;
        background-position: 0 -480px;
    }
    .norton-logo {
        height: 30px;
        width: 61px;
        background-position: 0 -540px;
    }
    .ups {
        height: 30px;
        width: 27px;
        background-position: 0 0;
    }
    .ems {
        height: 30px;
        width: 68px;
        background-position: 0 -570px;
    }
    .dhl {
        height: 30px;
        width: 76px;
        background-position: 0 -600px;
    }
`;
export const Copyright = styled.div `
    margin-top: 0;
    height: 40px;
    padding: 0;
    font-size: 12px;
    font-weight: normal;
    color: #ccc;
    background: #333;
    line-height: 40px;
    text-align: center;
`;
export const SearchList = styled.div `
    width: 229px;
    background: #FFFFFF;
    box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.05);
    position: absolute;
    padding: 2px 15px;
    box-sizing: border-box;
    span {
        display: block;
        width: 100%;
        padding: 3px 0px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
        overflow-x: scroll;
        overflow-y: hidden;
        box-sizing: border-box;

        &:hover {
            background: #E6E6E6;
        }
    }
    span::-webkit-scrollbar {
        display: none;
    }
`;
